<template>
  <div class="registration-card">
    <md-toolbar class="md-primary nav-style first-nav">
      <img src="../assets/logo.png" class="logo_navbar" />
    </md-toolbar>
    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>
    <form id="app" @submit.prevent="submitRegistration" class="card-doc-upload">
      <md-card md-with-hover>
        <md-card-area md-inset>
          <md-card-header>
            <div class="md-title title-style">Utente non registrato</div>
            <div class="md-subhead"></div>
          </md-card-header>
          <md-card-content>Il numero di telefono inserito non appartiene ad alcun utente registrato.</md-card-content>
        </md-card-area>
        <md-button
          class="md-raised md-accent"
          :md-ripple="false"
          :to="{ name: 'InsertPhone' }"
          style="text-align: center;"
        >Indietro</md-button>
        <br />
      </md-card>
    </form>
  </div>
</template>

<script>
import firebase from "firebase/app";
import parsley from "parsleyjs";

import $ from "jquery";
import axios from "axios";
import PatientUpload from "@/components/PatientUpload";
import "firebase/firestore";
import "firebase/auth";
import moment from "moment";
import { LoginChecker } from "@/utils/login-check";

export default {
  name: "NewPhone",
  data() {
    return {
      detailName: null,
      surname: null,
      surnameIsEmpty: false,
      name: null,
      nameIsEmpty: false,
      primaryMail: null,
      primaryMailIsEmpty: false,
      secondaryMail: null,
      secondaryMailIsEmpty: false,
      patientPhNo: null,
      patientPhNoIsEmpty: false,
      patientBirthDate: null,
      dataIsEmpty: false,
      privacy: false,
      data: null
    };
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */
.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.md-card {
  width: 60%;
  margin: 4px;
  display: inline-block;
  vertical-align: center;
}

.logo {
  margin-top: 60px;
  width: 10%;
  height: 10%;
}

.title-style {
  color: #027953;
  font-size: 20px;
}

.text-style {
  color: #027953;
  font-size: 15px;
  text-align: center;
  padding-top: 1%;
}

.logo_navbar {
  text-align: center;
  height: 40px;
  padding: 3px;
}

.logout {
  margin-top: 40px;
}

.home-button {
  width: 487px;
}

.nav-style {
  height: 50px;
}

.second-navbar {
  background-color: #027953;
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;
  padding: 1.3%;
}

.text-card {
  text-align: right;
  color: grey;
}

.first-nav {
  background-color: #ffffff !important;
}

.simple-text {
  color: black;
  font-size: 17px;
}

.button-text {
  padding-top: 6%;
  padding-left: 1%;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/NewPhone.vue